import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DocumentService } from '../../../../../../documents/document.service';
import { FileDetailsDTO, SignatureDTO } from '../../../../../../api/plyca-dtos';

@Component({
  selector: 'signature-tool-accordion',
  templateUrl: './signature-tool-accordion.component.html',
  styleUrls: ['./signature-tool-accordion.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignatureToolAccordionComponent {
  @Input() file: FileDetailsDTO;
  @Input() signaturesList: SignatureDTO[] = [];

  constructor(private _documentService: DocumentService) { }

  public validateSignDocument(signature: SignatureDTO, fileItem: FileDetailsDTO) {
    if (!signature.handWritten) {
      this._documentService.validateSignDocument(signature, fileItem);
    }
  }
}
